export default __webpack_public_path__ + "static/media/IconAttachment.66ab46ba.svg";